var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48047 5.65003L10.5805 3.25003C10.9805 2.85003 11.8805 2.65003 12.4805 2.65003H16.2805C17.4805 2.65003 18.7805 3.55003 19.0805 4.75003L21.4805 12.05C21.9805 13.45 21.0805 14.65 19.5805 14.65H15.5805C14.9805 14.65 14.4805 15.15 14.5805 15.85L15.0805 19.05C15.2805 19.95 14.6805 20.95 13.7805 21.25C12.9805 21.55 11.9805 21.15 11.5805 20.55L7.48047 14.45",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37988 5.6501V15.4501C2.37988 16.8501 2.97988 17.3501 4.37988 17.3501H5.37988C6.77988 17.3501 7.37988 16.8501 7.37988 15.4501V5.6501C7.37988 4.2501 6.77988 3.7501 5.37988 3.7501H4.37988C2.97988 3.7501 2.37988 4.2501 2.37988 5.6501Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.8fc6fc83.svg";
export { ForwardRef as ReactComponent };